import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { InspectionStorageService } from 'src/app/modules/course-accreditation/services/inspection-storage.service';
import { InspectionService } from 'src/app/modules/course-accreditation/services/inspection.service';
import { differenceInCalendarDays } from 'date-fns';
import { User } from 'src/app/modules/user/models/user.model';
import { ScheduleInspection } from 'src/app/modules/course-accreditation/models/schedule-inspection.model';
import { ListOfOccupation } from 'src/app/modules/course-accreditation/models/list-of-occupation.model';
import { InspectionOfficer } from 'src/app/modules/course-accreditation/models/inspectionOfficer';
import { OfficerComponent } from 'src/app/modules/course-accreditation/components/officer/officer.component';
import { environment } from 'src/environments/environment';
import { StpRegistrationRenewReapplyService } from '../../../services/stp-registration-renew-reapply.service';
import { InspectionSchedule } from 'src/app/modules/course-accreditation/models/inspection-schedule';
@Component({
  selector: 'app-inspection-scheduling',
  templateUrl: './inspection-scheduling.component.html',
  styleUrls: ['./inspection-scheduling.component.scss'],
})
export class InspectionSchedulingComponent implements OnInit {
  scheduleInspectionForm: FormGroup;
  today = new Date();

  //#region Inspection_Id
  inspectionId: any;
  //#endregion

  //#region stpMainId
  stpMainId: any;
  //#endregion

  //#region Model
  users: any;
  scheduleInspection: InspectionSchedule;
  scheduleInspectionList: InspectionSchedule[] = [];
  listOfOccupation: ListOfOccupation[] = [];
  representativeInspectionOfficerList: InspectionOfficer[] = [];
  inspectionOfficerList: InspectionOfficer[] = [];
  executiveChairmanList: InspectionOfficer[] = [];
  technicalInspectionOfficerList: InspectionOfficer[] = [];
  //#endregion

  //#region isRegistrationInspectionRequired
  stpSacRegistrationApplication: { id: boolean; name: string }[] = [
    { id: false, name: 'No' },
    { id: true, name: 'Yes' },
  ];
  //#endregion

  //#region isVerify
  paymentVerification: { id: boolean; name: string }[] = [
    { id: false, name: 'Failed' },
    { id: true, name: 'Successful' },
  ];

  isPaymentVerified: boolean = false;
  //#endregion

  //#region Pagination and sorting
  totalData: number = 0;
  pageSize: number = 10;
  currentPage: number = 1;
  sortingKey: string;
  sortingValue: string;
  //#endregion

  enableScheduleInspectionButton: boolean = false;

  //#region  for pagination
  total: number;
  size: number = 10;
  page: number = 1;
  //#endregion

  totalUser!: number;
  nsdaUser!: number;
  inspectorOfficer1!: number;
  inspectorOfficer2!: number;
  inspectorOfficer3!: number;
  inspectionLastDate: Date;

  paymentValidationControlList = [
    'inspectionLastDate',
    'nsdaUser',
    'contactNSDAOfficer',
    'emailNSDAOfficer',
    'isRegistrationInspectionRequired',
  ];

  saveButtonDisabled = false;
  // the schedule has been saved once, so the Save button reads Update
  isScheduleSaved = false;
  submitButtonDisabled = false;

  isRenewalApplication: boolean = false;
  
  applicationId: string;

  constructor(
    private fb: FormBuilder,
    private modal: NzModalService,
    private inspectionStorageService: InspectionStorageService,
    private stpRegistrationRenewReapplyService: StpRegistrationRenewReapplyService,
    private inspectionService: InspectionService,
    private router: Router,
    private route: ActivatedRoute,
    private notification: NzNotificationService,
  ) {
    //#region create form initialize
    this.createForm({} as any);
    //#endregion

    //#region pass parameter to router link
    this.stpMainId = this.route.snapshot.params.stpMainId;
    //#endregion

    const type = this.route.snapshot.paramMap.get('type');
    if (type === 'renewal') {
      this.isRenewalApplication = true;
    } else {
      this.isRenewalApplication = false;
    }

    //#region to get inspection officer
    this.inspectionStorageService.getInspectionOfficer().subscribe({
      next: (res) => {
        this.inspectionOfficerList = [...res.data];
        this.representativeInspectionOfficerList = [...res.data];
        this.technicalInspectionOfficerList = [...res.data];
        this.inspectionOfficerList.forEach((item, index) => {
          item.name = `${item.name} (${item.phone})`;
        });
      },
    });
    //#endregion

    this.getNsdaOfficerByTag();
  }

  ngOnInit(): void {
    this.invokeOfficerList();
  }

  getNsdaOfficerByTag() {
    //#region to get NSDA officer
    this.inspectionStorageService.getNSDAOfficer('nsda').subscribe({
      next: (res) => {
        this.users = [...res.data];

        this.users.forEach((item: any) => {
          item.name = `${item.designation} (${item.contactNo})`;
        });

        this.onScheduleInspectionByInspectionId();
      },
    });
    //#endregion
  }

  disabledDate = (current: Date): boolean =>
    // Can not select days before today and today
    differenceInCalendarDays(current, this.today) < 0;

  createForm(data: any) {
    this.scheduleInspectionForm = this.fb.group({
      //General Info
      stpOrSacName: data?.name,
      stpOrSacId: data?.registrationNo,
      addressofStpOrSac: data?.address,
      district: data?.district,
      applicationId: data?.applicationId,
      DateOfApplication: data?.applicationDate,

      //Payment Verification
      amount: data?.amount,
      DateofPayment: data?.paymentDate,
      bankName: data?.bankName,
      paymentProof: data?.applicationProof,
      isPaymentVerified: true,
      paymentFailedReason: data?.paymentFailedReason,

      //Schedule Inspection
      inspectionLastDate: [null, Validators.required],

      //NSDA User
      nsdaUserId: [null],
      nsdaUser: [null, Validators.required],
      contactNSDAOfficer: [null, Validators.required],
      emailNSDAOfficer: [null, Validators.required],

      //Inspector Officer1
      inspectorOfficer1Id: [null],
      inspectorOfficer1: [null],
      contactIscOrIndustryOfficer: [null],
      emailIscOrIndustryOfficer: [null],

      //Inspector Officer2
      inspectorOfficer2: [null],
      inspectorOfficer2Id: [null],
      contactTechnicalOfficer: [null],
      emailTechnicalOfficer: [null],

      //Inspector Officer3
      inspectorOfficer3: [null],
      inspectorOfficer3Id: [null],
      contactExecutiveChairman: [null],
      emailExecutiveChairman: [null],

      isRegistrationInspectionRequired: true,
    });
    this.scheduleInspectionForm
      .get('isPaymentVerified')
      ?.valueChanges.subscribe((value) => {
        if (value == 0) {
          this.scheduleInspectionForm.get('nsdaUser')?.clearValidators();
          this.scheduleInspectionForm.get('nsdaUser')?.updateValueAndValidity();
          this.scheduleInspectionForm
            .get('inspectorOfficer1')
            ?.clearValidators();
          this.scheduleInspectionForm
            .get('inspectorOfficer1')
            ?.updateValueAndValidity();
          this.scheduleInspectionForm
            .get('inspectorOfficer2')
            ?.clearValidators();
          this.scheduleInspectionForm
            .get('inspectorOfficer2')
            ?.updateValueAndValidity();
          this.scheduleInspectionForm
            .get('inspectorOfficer3')
            ?.clearValidators();
          this.scheduleInspectionForm
            .get('inspectorOfficer3')
            ?.updateValueAndValidity();
        }
      });
  }

  submitForm() {
    if (this.scheduleInspectionForm.invalid) {
      this.notification.info('Info!', 'Please input all required fields');
      return;
    }

    this.saveButtonDisabled = true;

    // the backend always answers "saved"; a second save is an update
    const isUpdate = this.isScheduleSaved;

    const formValue = this.scheduleInspectionForm.value;

    const payload = {
      inspectionId: this.inspectionId,
      stpMainId: this.stpMainId,

      isPaymentVerified: formValue.isPaymentVerified,
      paymentFailedReason: formValue.paymentFailedReason,

      inspectionLastDate: formValue.inspectionLastDate,

      nsdaUser: formValue.nsdaUser,

      inspectorOfficer1: formValue.inspectorOfficer1,
      inspectorOfficer2: formValue.inspectorOfficer2,
      inspectorOfficer3: formValue.inspectorOfficer3,

      isRegistrationInspectionRequired:
        formValue.isRegistrationInspectionRequired,
    };

    this.stpRegistrationRenewReapplyService
      .saveInspectionSchedule(payload)
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.inspectionId = response.data?.inspectionId;
            this.isScheduleSaved = true;
            this.notification.success('Success!', isUpdate ? 'Inspection schedule updated successfully!' : response.message);
            this.enableScheduleInspectionButton = true;
          } else {
            this.notification.error('Error!', response.message);
          }
          this.saveButtonDisabled = false;
        },
        error: (error) => {
          this.notification.error(
            'Failed',
            error?.error?.message || 'Server Error',
          );
          this.saveButtonDisabled = false;
        },
      });
  }

  //#region to get schedule inspection by inspection Id
  onScheduleInspectionByInspectionId(): void {
    const payload = {
      stpMainId: this.stpMainId,
      inspectionId: this.inspectionId,
    };
    this.stpRegistrationRenewReapplyService
      .readInspectionScheduleInfo(payload)
      .subscribe({
        next: (res) => {
          this.scheduleInspectionList = res.data;
          this.scheduleInspection = res.data;

          this.createForm(res.data);
          this.applicationId = res.data?.applicationId;
          this.inspectionId = res.data?.inspectionId;
          // the last date is required on save, so a saved schedule always has one
          this.isScheduleSaved = !!res.data?.inspectionLastDate;

          if (res.data?.isPaymentVerified) {
            this.isPaymentVerified = true;
          }

          this.inspectionLastDate == res.data?.inspectionLastDate;
          this.scheduleInspectionForm
            .get('inspectionLastDate')
            ?.patchValue(res.data?.inspectionLastDate);

          this.nsdaUser = res.data?.nsdaUser;
          this.scheduleInspectionForm
            .get('nsdaUser')
            ?.patchValue(res.data?.nsdaUser);

          if (this.nsdaUser != null) {
            this.onSelectNSDAOfficer(this.nsdaUser);
          }

          this.inspectorOfficer1 = res.data?.inspectorOfficer1;
          this.scheduleInspectionForm
            .get('inspectorOfficer1')
            ?.patchValue(res.data?.inspectorOfficer1);
          let inspectorOfficer1Obj = this.inspectionOfficerList.find(
            (o) => o.id == this.inspectorOfficer1,
          );
          this.scheduleInspectionForm
            .get('contactIscOrIndustryOfficer')
            ?.setValue(inspectorOfficer1Obj?.phone);
          this.scheduleInspectionForm
            .get('emailIscOrIndustryOfficer')
            ?.setValue(inspectorOfficer1Obj?.email);

          this.inspectorOfficer2 = res.data?.inspectorOfficer2;
          this.scheduleInspectionForm
            .get('inspectorOfficer2')
            ?.patchValue(res.data?.inspectorOfficer2);
          let inspectorOfficer2Obj = this.inspectionOfficerList.find(
            (o) => o.id == this.inspectorOfficer2,
          );
          this.scheduleInspectionForm
            .get('contactTechnicalOfficer')
            ?.setValue(inspectorOfficer2Obj?.phone);
          this.scheduleInspectionForm
            .get('emailTechnicalOfficer')
            ?.setValue(inspectorOfficer2Obj?.email);

          this.inspectorOfficer3 = res.data?.inspectorOfficer3;
          this.scheduleInspectionForm
            .get('inspectorOfficer3')
            ?.patchValue(res.data?.inspectorOfficer3);
          let inspectorOfficer3Obj = this.inspectionOfficerList.find(
            (o) => o.id == this.inspectorOfficer3,
          );
          this.scheduleInspectionForm
            .get('contactExecutiveChairman')
            ?.setValue(inspectorOfficer3Obj?.phone);
          this.scheduleInspectionForm
            .get('emailExecutiveChairman')
            ?.setValue(inspectorOfficer3Obj?.email);

          this.onPaymentVerificationChange(
            this.scheduleInspection?.isPaymentVerified,
          );
        },
      });
  }
  //#endregion

  //#region On Select NSDA Officer
  onSelectNSDAOfficer(id: any): void {
    let emailForNSDAOfficer = this.users.find(
      (officer: any) => officer.id === id,
    );
    let phoneForNSDAOfficer = this.users.find(
      (contactNumber: any) => contactNumber.id === id,
    );
    if (emailForNSDAOfficer && phoneForNSDAOfficer) {
      this.scheduleInspectionForm
        .get('emailNSDAOfficer')
        ?.setValue(emailForNSDAOfficer.email);
      this.scheduleInspectionForm
        .get('contactNSDAOfficer')
        ?.setValue(phoneForNSDAOfficer.contactNo);
    }
  }
  //#endregion

  //#region Inspector Officer1
  onSelectOfficer1(id: any): void {
    let officerList = [...this.inspectionOfficerList];
    let officerIndex = officerList.findIndex(
      (selectedOfficer) => selectedOfficer.id === id,
    );

    if (officerIndex != -1) {
      officerList.splice(officerIndex, 1);
    }
    this.representativeInspectionOfficerList = officerList;

    let email = this.inspectionOfficerList.find((officer) => officer.id === id);

    let contactNumber = this.inspectionOfficerList.find(
      (contactNumber) => contactNumber.id === id,
    );

    if (email && contactNumber) {
      this.scheduleInspectionForm
        .get('emailIscOrIndustryOfficer')
        ?.setValue(email.email);
      this.scheduleInspectionForm
        .get('contactIscOrIndustryOfficer')
        ?.setValue(contactNumber.phone);
    }
  }
  //#endregion

  //#region Inspector Officer2
  onSelectOfficer2(id: number): void {
    let officerList = [...this.representativeInspectionOfficerList];
    let officerIndex = officerList.findIndex(
      (selectedOfficer) => selectedOfficer.id === id,
    );

    if (officerIndex != -1) {
      officerList.splice(officerIndex, 1);
    }
    this.technicalInspectionOfficerList = officerList;

    let emailIscOrIndustryOfficer =
      this.representativeInspectionOfficerList.find(
        (officer) => officer.id === id,
      );

    let contactIscOrIndustryOfficer =
      this.representativeInspectionOfficerList.find(
        (contactNumber) => contactNumber.id === id,
      );

    if (emailIscOrIndustryOfficer && contactIscOrIndustryOfficer) {
      this.scheduleInspectionForm
        .get('emailTechnicalOfficer')
        ?.setValue(emailIscOrIndustryOfficer.email);
      this.scheduleInspectionForm
        .get('contactTechnicalOfficer')
        ?.setValue(contactIscOrIndustryOfficer.phone);
    }
  }
  //#endregion

  //#region Inspector Officer 3
  onSelectOfficer3(id: number): void {
    let emailTechnicalOfficer = this.technicalInspectionOfficerList.find(
      (officer) => officer.id === id,
    );

    let contactTechnicalOfficer = this.technicalInspectionOfficerList.find(
      (contactNumber) => contactNumber.id === id,
    );

    if (emailTechnicalOfficer && contactTechnicalOfficer) {
      this.scheduleInspectionForm
        .get('emailExecutiveChairman')
        ?.setValue(emailTechnicalOfficer.email);
      this.scheduleInspectionForm
        .get('contactExecutiveChairman')
        ?.setValue(contactTechnicalOfficer.phone);
    }
  }
  //#endregion

  //#region  Modal
  createCustomButtonModal(): void {
    const modal: NzModalRef = this.modal.create({
      nzContent: OfficerComponent,
      nzClosable: false,
      nzOkText: null,
      nzWidth: 1000,
    });
  }
  //#endregion

  //#region Reset
  resetForm() {
    this.scheduleInspectionForm.reset();
    this.technicalInspectionOfficerList = [];
    this.representativeInspectionOfficerList = [];
    this.executiveChairmanList = [];
    this.listOfOccupation = [];
    this.scheduleInspectionList = [];
  }
  //#endregion

  async onPaymentProofDownload() {
    const data = await fetch(
      environment.fileServiceApiUrl + this.scheduleInspection.applicationProof,
    );
    if (!data.ok) {
      this.notification.error('Error!', 'File Not Found');
      return;
    }
    const blob = await data.blob();
    const fileBase64 = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.setAttribute('target', '_blank');
    link.setAttribute('href', fileBase64);
    link.setAttribute('download', 'PaymentProof');
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  onPaymentVerificationChange(isPaymentVerified: any) {
    if (this.scheduleInspection)
      this.scheduleInspection.isPaymentVerified = isPaymentVerified;
    // if (!isPaymentVerified) {
    //   this.scheduleInspectionForm.controls['paymentFailedReason'].setValidators(
    //     [Validators.required]
    //   );
    //   this.scheduleInspectionForm.controls[
    //     'paymentFailedReason'
    //   ].updateValueAndValidity();

    //   this.paymentValidationControlList.forEach((control: string) => {
    //     this.scheduleInspectionForm.controls[control].setErrors(null);
    //     this.scheduleInspectionForm.controls[control].clearValidators();
    //     this.scheduleInspectionForm.controls[control].updateValueAndValidity();
    //   });
    // } else {
    this.scheduleInspectionForm.controls['paymentFailedReason'].setErrors(null);
    this.scheduleInspectionForm.controls[
      'paymentFailedReason'
    ].clearValidators();
    this.scheduleInspectionForm.controls[
      'paymentFailedReason'
    ].updateValueAndValidity();

    this.paymentValidationControlList.forEach((control: string) => {
      this.scheduleInspectionForm.controls[control].setValidators([
        Validators.required,
      ]);
      this.scheduleInspectionForm.controls[control].updateValueAndValidity();
    });
    // }
  }

  //#region submit schedule inspection by inspection Id
  onSubmitStpScheduleInspection() {
    this.submitButtonDisabled = true;
    this.stpRegistrationRenewReapplyService
      .submitInspectionSchedule(this.inspectionId)
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.notification.success('Success!', res.message);
            const path = this.isRenewalApplication
              ? '/home/stp-registration/stp-renewal-application-list'
              : '/home/stp-registration/stp-reapply-application-list';

            this.router.navigate([path]);
          } else {
            this.notification.error('Failed!', res.message);
            this.submitButtonDisabled = false;
          }
        },
        error: (error) => {
          this.notification.error('Failed', error);
          this.submitButtonDisabled = false;
        },
      });
  }
  //#endregion

  invokeOfficerList() {
    this.inspectionService.inspectorOfficerSubject?.subscribe((res) => {
      if (res != null) {
        res.name = `${res.name} (${res.phone})`;
        this.representativeInspectionOfficerList.push(res);
        this.inspectionOfficerList.push(res);
        this.technicalInspectionOfficerList.push(res);
      }
    });
  }
}
